var isObject = require('./_is-object');
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};



// WEBPACK FOOTER //
// ./~/@babel/polyfill/~/core-js/modules/_validate-collection.js